
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.065 15.773H12.46a3.185 3.185 0 00-3.19 3.176v21.265a3.185 3.185 0 003.19 3.176h35.605c1.76 0 3.19-1.424 3.19-3.176V18.95c.01-1.753-1.43-3.176-3.19-3.176zM12.46 17.764h35.605c.66 0 1.19.538 1.19 1.185v3.414H11.26V18.95c.01-.657.54-1.185 1.2-1.185zm35.605 23.645H12.46a1.19 1.19 0 01-1.19-1.185v-15.87h37.995v15.87c0 .647-.54 1.185-1.2 1.185z"}}),_c('path',{attrs:{"d":"M26.288 28.586H17.12a1 1 0 00-1 .995 1 1 0 001 .996h9.17a1 1 0 00.999-.996 1 1 0 00-1-.995z"}})])
          )
        }
      }
    